"use client";
import { usePublicLocale } from "../../public-locale";
import { withPublicLocale } from "../../../lib/public-locale";
import { createContext, useContext } from "react";
type MarketingAppLinks = { signInHref: string };
const MarketingAppLinkContext = createContext<MarketingAppLinks>({ signInHref: "/sign-in" });
export function MarketingAppLinkProvider({ signInHref, children }: { signInHref: string; children: React.ReactNode }) {
  const locale = usePublicLocale();
  return <MarketingAppLinkContext.Provider value={{ signInHref: withPublicLocale(signInHref, locale) }}>{children}</MarketingAppLinkContext.Provider>;
}
export function useMarketingAppLinks() { return useContext(MarketingAppLinkContext); }
